export default __webpack_public_path__ + "static/media/history.c8f6477c.png";